<template>
  <e-collapse title="基础设置" :expand="true">

    <t-form-item label="label">
      <t-input size="small" v-model="attribute.label" />
    </t-form-item>
    <t-form-item label="显示label"
      v-if="currentCpt.cptKey == 'cpt-textarea' || currentCpt.cptKey == 'cpt-select' || currentCpt.cptKey == 'cpt-select-mobile' || currentCpt.cptKey == 'cpt-input' || currentCpt.cptKey == 'cpt-input-mobile'">
      <t-switch v-model="attribute.labelBoolean" size="small" :label="['显示', '关闭']" />
    </t-form-item>
    <t-form-item label="label宽度"
      v-if="currentCpt.cptKey == 'cpt-textarea' || currentCpt.cptKey == 'cpt-input' || currentCpt.cptKey == 'cpt-input-mobile'">
      <t-input-number size="small" :min="0" :max="9999" v-model="attribute.labelWidth" :decimal-places="0" />
    </t-form-item>
    <t-form-item label="label位置">
      <t-radio-group size="small" v-model="attribute.labelAlign">
        <t-radio-button value="left">左部</t-radio-button>
        <t-radio-button value="right">右部</t-radio-button>
        <t-radio-button value="top">顶部</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <!-- <t-form-item label="label宽度">
      <t-input-number
        size="small"
        :min="0"
        :max="9999"
        v-model="attribute.labelWidth"
        :decimal-places="0"
      />
    </t-form-item> -->
    <t-form-item label="占位符">
      <t-input size="small" v-model="attribute.placeholder" />
    </t-form-item>
    <t-form-item label="最小值" v-if="currentCpt.cptKey === 'cpt-number'">
      <t-input-number size="small" v-model="attribute.min" />
    </t-form-item>
    <t-form-item label="最大值" v-if="currentCpt.cptKey === 'cpt-number'">
      <t-input-number size="small" v-model="attribute.max" />
    </t-form-item>
    <t-form-item label="可输入">
      <t-switch size="small" v-model="attribute.isInput" :label="['是', '否']" />
    </t-form-item>
    <t-form-item label="尺寸">
      <t-radio-group size="small" v-model="attribute.size" @change="changeSize">
        <t-radio-button value="small">小</t-radio-button>
        <t-radio-button value="medium">中</t-radio-button>
        <t-radio-button value="large">大</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="宽度">
      <t-input-number size="small" :min="0" :max="9999" v-model="currentCpt.cptWidth" :decimal-places="0"
        disabled="true" />
    </t-form-item>
    <t-form-item label="自动高度" v-if="currentCpt.cptKey == 'cpt-textarea'">
      <t-switch v-model="attribute.autosize" size="small" :label="['是', '否']" />
    </t-form-item>
    <t-form-item label="高度">
      <t-input-number size="small" :min="0" :max="9999" v-model="attribute.height" :decimal-places="0"
        :disabled="currentCpt.cptKey == 'cpt-textarea' && attribute.autosize" />
    </t-form-item>

    <t-form-item label="对齐方式">
      <t-radio-group size="small" v-model="attribute.align">
        <t-radio-button value="left">居左</t-radio-button>
        <t-radio-button value="center">居中</t-radio-button>
        <t-radio-button value="right">居右</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="缩进">
      <t-input-number size="small" v-model="attribute.indent" theme="normal" align="left" :min="0" :max="9999"
        :decimal-places="0">
        <template #suffix><span>px</span></template>
      </t-input-number>
    </t-form-item>
    <t-form-item label="最大长度" v-if="currentCpt.cptKey == 'cpt-textarea'">
      <t-input-number size="small" v-model="attribute.maxlength" theme="normal" align="left" :min="0"
        :max="10000000000000" :decimal-places="0" placeholder="请输入">
      </t-input-number>
    </t-form-item>
    <t-form-item label="禁用" v-if="currentCpt.cptKey == 'cpt-textarea'">
      <t-switch v-model="attribute.disabled" size="small" :label="['是', '否']" />
    </t-form-item>
    <t-form-item label="禁用背景颜色" v-if="currentCpt.cptKey == 'cpt-textarea' && attribute.disabled">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.disabledColor" />
    </t-form-item>
    <t-form-item label="只读" v-if="currentCpt.cptKey == 'cpt-textarea'">
      <t-switch v-model="attribute.readonly" size="small" :label="['是', '否']" />
    </t-form-item>
    <t-form-item label="背景色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha v-model="attribute.bgColor" />
    </t-form-item>

    <t-form-item label="密码等级" v-if="currentCpt.cptKey == 'cpt-password'">
      <t-radio-group size="small" v-model="attribute.psLevel">
        <t-radio-button value="small">低级</t-radio-button>
        <t-radio-button value="medium">中级</t-radio-button>
        <t-radio-button value="large">高级</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="显示图标" v-if="
      currentCpt.cptKey == 'cpt-time-picker' ||
      currentCpt.cptKey == 'cpt-date-picker' ||
      currentCpt.cptKey == 'cpt-select'
    ">
      <t-switch v-model="attribute.timeIcon" />
    </t-form-item>
    <t-form-item label="是否搜索" v-if="currentCpt.cptKey == 'cpt-select'">
      <t-switch v-model="attribute.filterable" />
    </t-form-item>

    <t-form-item label="日期排列方式" v-if="currentCpt.cptKey == 'cpt-date-picker'">
      <t-radio-group size="small" v-model="attribute.direction">
        <t-radio-button value="row">横向</t-radio-button>
        <t-radio-button value="column">竖向</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="布局" v-if="currentCpt.cptKey == 'cpt-number'">
      <t-radio-group size="small" v-model="attribute.theme">
        <t-radio-button value="normal">normal</t-radio-button>
        <t-radio-button value="column">column</t-radio-button>
        <t-radio-button value="row">row</t-radio-button>
      </t-radio-group>
    </t-form-item>

    <!-- <t-form-item label="图标颜色" v-if="currentCpt.cptKey == 'cpt-time-picker' || currentCpt.cptKey == 'cpt-date-picker'">
    <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.timeIconBg"
      />
    </t-form-item>  -->
  </e-collapse>
  <e-collapse title="字体设置" :expand="true">
    <t-form-item label="字体颜色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.textColor" />
    </t-form-item>
    <t-form-item label="提示字体颜色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.textPlaceholderColor" />
    </t-form-item>
    <t-form-item label="字体样式">
      <t-radio-group size="small" v-model="attribute.fontStyle">
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="italic">斜体</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="加粗">
      <t-radio-group size="small" v-model="attribute.fontWeight">
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="bold">加粗</t-radio-button>
        <t-radio-button value="lighter">更细</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="字体">
      <t-select size="small" v-model="attribute.fontFamily">
        <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
      </t-select>
    </t-form-item>
    <t-form-item label="字体大小">
      <t-input-number size="small" :min="0" :max="9999" v-model="attribute.fontSize" :decimal-places="0" />
    </t-form-item>
  </e-collapse>
  <e-collapse title="图标设置" :expand="true" v-if="currentCpt.cptKey == 'cpt-select'">
    <t-form-item label="图标颜色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.disableColor" />
    </t-form-item>
    <t-form-item label="图标选中颜色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.activeBgColor" />
    </t-form-item>
  </e-collapse>
  <e-collapse title="边框设置" :expand="false">
    <t-form-item label="边框宽度">
      <t-input-number size="small" v-model="attribute.borderSize" :min="0" :max="9999" :decimal-places="0" />
    </t-form-item>
    <t-form-item label="边框颜色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.borderColor" />
    </t-form-item>
    <t-form-item label="边框圆角">
      <t-input-number size="small" v-model="attribute.borderRadius" :min="0" :max="9999" :decimal-places="0" />
    </t-form-item>
    <t-form-item label="线条类型">
      <t-select size="small" v-model="attribute.lineType">
        <t-option v-for="item in lineTypeList" :key="item.value" :label="item.label" :value="item.value" />
      </t-select>
    </t-form-item>
  </e-collapse>
  <e-collapse title="下拉框设置" v-if="currentCpt.cptKey == 'cpt-select'">
    <t-form-item label="下拉背景色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.optionBg" />
    </t-form-item>
    <t-form-item label="下拉字体色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.optionColor" />

    </t-form-item>
    <t-form-item label="下拉字体大小">
      <t-input-number size="small" :min="0" :max="9999" v-model="attribute.optionFontSize" :decimal-places="0" />

    </t-form-item>
    <t-form-item label="下拉选中背景色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.optionSelectedBg" />

    </t-form-item>
    <t-form-item label="下拉选中字体色">
      <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
        v-model="attribute.optionSelectedColor" />

    </t-form-item>
  </e-collapse>


  <e-collapse title="布局为row" :expand="false" v-if="currentCpt.cptKey == 'cpt-number' && attribute.theme == 'row'">
    <e-collapse title="加符样式">
      <t-form-item label="加符颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.incNumberColor" />
      </t-form-item>
      <t-form-item label="加符背景颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.incNumberBg" />
      </t-form-item>
      <t-form-item label="加符边框宽度">
        <t-input-number size="small" v-model="attribute.incNumberborderSize" :min="0" :max="9999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="加符边框颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.incNumberborderColor" />
      </t-form-item>
      <t-form-item label="加符边框圆角">
        <t-input-number size="small" v-model="attribute.incNumberborderRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="加符线条类型">
        <t-select size="small" v-model="attribute.incNumberlineType">
          <t-option v-for="item in lineTypeList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
    </e-collapse>
    <e-collapse title="减符样式">
      <t-form-item label="减符颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.decNumberColor" />
      </t-form-item>
      <t-form-item label="减符背景颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.decNumberBg" />
      </t-form-item>
      <t-form-item label="减符边框宽度">
        <t-input-number size="small" v-model="attribute.decNumberborderSize" :min="0" :max="9999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="减符边框颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.decNumberborderColor" />
      </t-form-item>
      <t-form-item label="减符边框圆角">
        <t-input-number size="small" v-model="attribute.decNumberborderRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="减符线条类型">
        <t-select size="small" v-model="attribute.decNumberlineType">
          <t-option v-for="item in lineTypeList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
    </e-collapse>
  </e-collapse>
  <e-collapse title="布局为row选中" :expand="false" v-if="currentCpt.cptKey == 'cpt-number' && attribute.theme == 'row'">
    <e-collapse title="加符样式">
      <t-form-item label="加符颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.incNumberActivColor" />
      </t-form-item>
      <t-form-item label="加符背景颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.incNumberActivBg" />
      </t-form-item>
      <t-form-item label="加符边框宽度">
        <t-input-number size="small" v-model="attribute.incNumberActiveborderSize" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="加符边框颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.incNumberActivborderColor" />
      </t-form-item>
      <t-form-item label="加符边框圆角">
        <t-input-number size="small" v-model="attribute.incNumberActivborderRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="加符线条类型">
        <t-select size="small" v-model="attribute.incNumberActivlineType">
          <t-option v-for="item in lineTypeList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
    </e-collapse>

    <e-collapse title="减符样式">
      <t-form-item label="减符颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.decNumberActivColor" />
      </t-form-item>
      <t-form-item label="减符背景颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.decNumberActivBg" />
      </t-form-item>
      <t-form-item label="减符边框宽度">
        <t-input-number size="small" v-model="attribute.decNumberActiveborderSize" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="减符边框颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.decNumberActivborderColor" />
      </t-form-item>
      <t-form-item label="减符边框圆角">
        <t-input-number size="small" v-model="attribute.decNumberActivborderRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="减符线条类型">
        <t-select size="small" v-model="attribute.decNumberActivlineType">
          <t-option v-for="item in lineTypeList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
    </e-collapse>
  </e-collapse>
  <e-collapse title="校验设置" :expand="true" v-if="currentCpt.cptKey != 'cpt-password'">
    <t-form-item label="必填标识">
      <t-switch size="small" v-model="attribute.required" :label="['是', '否']" />
    </t-form-item>
  </e-collapse>
</template>

<script>
export default {
  name: "cpt-input-option-base",
  props: {
    attribute: Object,
    currentCpt: Object,
  },
  data() {
    return {
      textFamilyList: [],
    }
  },
  created() {
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");

    console.log(this.currentCpt, "currentCpt");
  },
  methods: {
    changeSize(val) {
      this.$emit("changeSize", val);
    },
  },
};
</script>

<style></style>